import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@mui/styles'

import lang from 'lang'
import Loader from '../../../../base/components/loader/loader'
import CheckIcon from 'assets/images/icons/check.svg'
import { BookingService } from '../../../services'
import { ModalBig } from '../../../../base/components/modal'
import { CancelButton, ButtonIconSquare } from '../../../../base/components/buttons'

class DeleteRevenueModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }

    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillUnmount() {
    this.setState({ agrees: false })
  }

  handleConfirm() {
    const { id, handleConfirm, handleError } = this.props

    this.setState({ isLoading: true }, () => {
      return BookingService.removeAssignments(id)
        .then(handleConfirm)
        .catch(handleError)
        .finally(() => {
          this.setState({ isLoading: false })
        })
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.handleConfirm()
  }

  render() {
    const { loading } = this.state
    const { classes, handleAbort } = this.props

    const buttons = [
      <CancelButton
        key='cancel'
        type='cancel'
        label={lang.cancelButtonLabel}
        onClick={handleAbort} />,
      <ButtonIconSquare
        key='confirm'
        customClass={classes.actionButton}
        type='submit'
        icon={CheckIcon}
        label={lang.confirmButtonLabel}
        onClick={this.handleSubmit} />,
    ]

    return (
      <ModalBig
        disableEscapeKeyDown
        disableBackdropClick
        open={true}
        title={lang.bookingAssignmentDeleteRevenueModalTitle}
        actions={buttons}
        onClose={handleAbort}>
        <Loader customClass={classes.loader} visible={loading} />
        <div className={classes.content}>
          <div>
            <p>
                            {lang.bookingAssignmentDeleteRevenueModalText}
            </p>
          </div>
          <form className={classes.form} onSubmit={this.handleSubmit} />
        </div>
      </ModalBig>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    banking: {
      bankAccountList: { selectedBankAccount, contextMenu },
    },
  } = state

  return {
    selectedBankAccount,
    contextMenu,
  }
}

DeleteRevenueModal.defaultProps = {
  open: false,
}

const styles = theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  loader: {
    height: '100%',
  },
  form: {
    padding: '0px 15px',
    marginBottom: 25,
  },
  actionButton: {
    marginLeft: 15,
  },
})

export default connect(mapStateToProps)(withStyles(styles)(DeleteRevenueModal))
